import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDDomicileBodyModel } from 'src/app/model/MDDomicileBodyModel';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-md-domicile',
  templateUrl: './md-domicile.component.html',
  styleUrls: []
})
export class MDDomicileComponent implements OnInit {
  @Input() registrationModerationDocument: RegistrationModerationDocumentModel;
  verifyForm: FormGroup = new FormGroup({});
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  @Output() onSubmit = new EventEmitter<MDDomicileBodyModel>();
  departments: string[] = [];

  constructor() { }

  ngOnInit(): void { 
    console.log(this.registrationModerationDocument);
    this.verifyForm = new FormGroup({
      isDocReadable: new FormControl(null, [Validators.required]),
      hasBarcode: new FormControl(null, [Validators.required]),
      afterPeriod: new FormControl(null, [Validators.required]),
      barcode: new FormControl(null, [Validators.required]),
      reEnterBarcode: new FormControl(null, [Validators.required]),
    });
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      this.onSubmit.emit(new MDDomicileBodyModel(
        this.verifyForm.value.isDocReadable,
        this.verifyForm.value.hasBarcode,
        this.verifyForm.value.afterPeriod,
        this.verifyForm.value.barcode,
        this.verifyForm.value.reEnterBarcode,
        ));
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }
}
